export function toHttps(url) {
    return url.replace('http://', 'https://');
}
